import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.updateCostsForm.title, 'Update costs'),
  decoratorPriceExclTax: () => __(translations.updateCostsForm.decoratorPriceExclTax, 'Decorator Price (Excl. tax)'),
  publicPriceExclTax: () => __(translations.updateCostsForm.publicPrice, 'Public price  (Excl. tax)'),
  resellerPriceExclTax: () => __(translations.updateCostsForm.resellerPriceExclTax, 'Reseller price (Excl. tax)'),
};
